<template>
  <div class="app-content container">
    <section class="emta-success">
      <div class="bg-white shadow-sm p-5 my-3" style="border-radius: 10px">
        <div class="alert alert-solid-dark" >

          <div class="mx-auto text-center" style="max-width: 400px">
            <div style="line-height: 1.2em">
              <div class="d-flex justify-content-center my-4">
                <div>
                  <img :src="currentLogo" alt="paystar">
                </div>
              </div>
              <h4 class="text-white-in-dark-mode">
                به پی استار خوش آمدید
              </h4>

            </div>
          </div>
        </div>
        <div v-if="success_message" class="alert alert-success mb-4">{{ success_message }}</div>
        <vue-recaptcha
            v-if="captchaDriver === 'recaptcha'"
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="sitekey"
            :loadRecaptchaScript="true"
        >
        </vue-recaptcha>
        <arcaptcha-vue
            v-if="captchaDriver === 'arcaptcha'"
            ref="arcaptcha"
            :site_key="arCaptchaKey"
            :invisible="true"
            :callback="onArcaptchaSuccess"
            :expired_callback="onArcaptchaExpired"
            :error_callback="onArcaptchaError"
        />
        <kt-row>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="domain">
                {{ $t('emta_services.domain') }}
              </kt-form-label>
              <kt-form-control
                id="domain"
                name="domain"
                :value="emtaInfo.domain"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="nameper">
                {{ $t('emta_services.nameper') }}
              </kt-form-label>
              <kt-form-control
                id="nameper"
                name="nameper"
                :value="emtaInfo.nameper"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="approvedate">
                {{ $t('emta_services.approvedate') }}
              </kt-form-label>
              <kt-form-control
                id="approvedate"
                name="approvedate"
                :value="emtaInfo.approve_date"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="expdate">
                 {{ $t('emta_services.expdate') }}
              </kt-form-label>
              <kt-form-control
                id="expdate"
                name="expdate"
                :value="emtaInfo.expdate"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="usertype">
                {{ $t('emta_services.usertype') }}
              </kt-form-label>
              <kt-form-control
                id="usertype"
                name="usertype"
                :value="emtaInfo.user_type  === userTypes.REAL ? userTypesStr.REAL: userTypesStr.LEGAL"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="national">
                {{ $t('emta_services.national') }}
              </kt-form-label>
              <kt-form-control
                id="national"
                name="national"
                :value="emtaInfo.national"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="fullname">
                {{ $t('emta_services.fullname') }}
              </kt-form-label>
              <kt-form-control
                id="fullname"
                name="fullname"
                :value="emtaInfo.fullname"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12"  v-if="emtaInfo.user_type == userTypes.REAL">
            <kt-form-group>
              <kt-form-label for="mobile">
                 {{ $t('emta_services.mobile') }}
              </kt-form-label>
              <kt-form-control
                id="mobile"
                name="mobile"
                :value="emtaInfo.mobile"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
           <kt-col lg="6" md="6" xs="12" v-if="emtaInfo.user_type == userTypes.LEGAL">
            <kt-form-group>
              <kt-form-label for="manager_mobile">
                  {{ $t('emta_services.manager_mobile') }}
              </kt-form-label>
              <kt-form-control
                id="manager_mobile"
                name="manager_mobile"
                :value="emtaInfo.manager_mobile"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="phone">
                {{ $t('emta_services.phone') }}
              </kt-form-label>
              <kt-form-control
                id="phone"
                name="phone"
                :value="emtaInfo.phone"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="state">
                {{ $t('emta_services.state') }}
              </kt-form-label>
              <kt-form-control
                id="state"
                name="state"
                :value="emtaInfo.state"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="city">
                {{ $t('emta_services.city') }}
              </kt-form-label>
              <kt-form-control
                id="city"
                name="city"
                :value="emtaInfo.city"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="postal_code">
                {{ $t('emta_services.postal_code') }}
              </kt-form-label>
              <kt-form-control
                id="postal_code"
                name="postal_code"
                :value="emtaInfo.postal_code"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="address">
                {{ $t('emta_services.address') }}
              </kt-form-label>
              <kt-form-control
                id="address"
                name="address"
                :value="emtaInfo.state +'-' + emtaInfo.city + '-' + emtaInfo.postal_code"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
           <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="services">
                {{ $t('emta_services.services') }}
              </kt-form-label>
              <kt-form-control
                id="services"
                name="services"
                :value="service"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="tax_code">
                {{ $t('emta_services.tax_code') }}
              </kt-form-label>
              <kt-form-control
                id="tax_code"
                name="tax_code"
                :value="emtaInfo.taxcode"
                disabled
              >
              </kt-form-control> </kt-form-group
            >
          </kt-col>
        </kt-row>
        <ket-row class="text-center">
          <kt-col>
            <button class="btn btn-warning  rounded"
                    :disabled="loading"
                    :style="loading ? 'cursor: unset': 'cursor: pointer'"
                    @click="onSubmit()">
              <span class="spinner-border" v-if="loading"></span>
              <span v-else>تکمیل فرایند ثبت درگاه</span>
            </button>
          </kt-col>
        </ket-row>
        <div>
            <hr>
            <div class="support mt-for-footer" style="font-size: 14px!important;">
                <div class="container mx-auto d-flex row">
                    <div class="col-12 col-lg-4 text-center">
                        <span>7 روز هفته ، از ساعت 8 الی 20 پاسخگوی شما هستیم</span>
                    </div>
                    <div class="master-footer-b col-12 col-lg-4 d-flex mt-3 mt-lg-0 justify-content-center justify-content-lg-around">
                        <a href="tel:021-91300818" class="">
                            <div class="d-flex align-items-center mx-2 mx-lg-0">
                                <div class="d-flex flex-column ml-1">
                                    <span class="info">021-91300818</span>
<!--                                    <span class="info">09120510443</span>-->
                                </div>
                                <i class="fa fa-phone-volume fa-2x"></i>
                            </div>
                        </a>
                    </div>
                    <div class="master-footer-b col-12 col-lg-4 d-flex mt-3 mt-lg-0 justify-content-center justify-content-lg-around">
                        <div class="d-flex align-items-center  mx-2 mx-lg-0">
                            <span class="info ml-1">support@paystar.ir</span>
                            <i class="fa flaticon-email fa-2x"></i>

                            <!--                            <img src="/homepage/image/mail.svg" alt="ایمیل">-->
                        </div>

                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { enamadServices } from '@/common/api.service';
import { userTypes } from '@/constants/userTypes';
import {userTypesStr} from "../../../constants/userTypes";
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import VueRecaptcha from "vue-recaptcha";
import ArcaptchaVue from 'arcaptcha-vue'
import {load} from "rtlcss/lib/config-loader";

export default {
  name: "emtaSuccess",
  computed: {
    userTypesStr() {
      return userTypesStr
    },
    service() {
      return this.emtaInfo.services[0].service + '-' + this.emtaInfo.services[0].servicesid;
    },
    currentLogo() {
      return this.currentTheme === 'dark' 
        ? '/assets/logo_new_light.png'
        : '/assets/logo_new_dark.png';
    }
  },
  data(){
    return {
      userTypes,
      emtaInfo: {},
      isDark: false,
      success_message: '',
      g_recaptcha_response: "",
      recaptcha_verified: false,
      sitekey: reCaptchaKeys,
      arCaptchaKey: arCaptchaKeys,
      captchaDriver: getCaptchaDriver,
      loading: false,
      arcaptchaToken: '',
      arcaptchaVerified: false,
      currentTheme: 'dark'
    }
  },
  components: {
    'vue-recaptcha': VueRecaptcha,
    ArcaptchaVue
  },
   mounted(){
    this.loading = true;
    enamadServices.getNamadInfo(this.$route.params.shop_id).then(response => {
      this.emtaInfo = response.data.data
      this.loading = false;
      this.success_message = response.data.message
    }).catch(error => {
      throw new Error(error)
    })
    
    this.updateTheme();
    this.setupThemeListener();
  },
  beforeDestroy() {
    if (this.themeCheckInterval) {
      clearInterval(this.themeCheckInterval);
    }
    window.removeEventListener('storage', this.updateTheme);
    window.removeEventListener('themeChanged', this.updateTheme);
  },
  methods: {
    load,
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'light';
    },
    setupThemeListener() {
      window.addEventListener('storage', (e) => {
        if (e.key === 'AppUiTheme') {
          this.updateTheme();
        }
      });

      window.addEventListener('themeChanged', () => {
        this.updateTheme();
      });

      this.themeCheckInterval = setInterval(() => {
        const newTheme = window.localStorage.getItem('AppUiTheme') || 'light';
        if (newTheme !== this.currentTheme) {
          this.currentTheme = newTheme;
        }
      }, 100);
    },
    login(username) {
      let params = {
        outh_param: username,
        password: username,
        verfy_url: this.$url("verify"),
      };

      if (this.captchaDriver === 'recaptcha') {
        params['g-recaptcha-response'] = this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
        params['g-recaptcha-response'] = this.arcaptchaToken;
      }

      this.loading = true;
      const vm = this;
      this.$store.dispatch("auth/login", params).then(
          (response) => {
            this.loading = false;
            window.location.replace(this.$url(""));
          },
          (error) => {
            alert('شما قبلا این مراحل را گذارنده اید.')
            this.loading = false;
            this.is_login_pending = false;
            this.error_message = error.data.message;

            this.recaptcha_verified = false;
            this.resetCaptcha();
          }
      );
    },
    onSubmit(){
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.invisibleRecaptcha.execute();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
        this.$refs.arcaptcha.execute();
      } else if (!this.captchaDriver || this.captchaDriver === 'none') {
        this.login(this.emtaInfo.mobile);
      }
    },
    onVerify: function (response) {
      this.recaptcha_verified = true;
      this.g_recaptcha_response = response;
      this.login(this.emtaInfo.mobile);
    },
    onExpired: function () {
      this.recaptcha_verified = false;
    },
    onArcaptchaSuccess(token) {
      this.arcaptchaToken = token;
      this.arcaptchaVerified = true;
      this.login(this.emtaInfo.mobile);
    },
    onArcaptchaExpired() {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
    },
    onArcaptchaError(error) {
      this.arcaptchaVerified = false;
      this.arcaptchaToken = '';
    },
    resetCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.invisibleRecaptcha.reset();
      } else if (this.captchaDriver === 'arcaptcha') {
        this.$refs.arcaptcha.reset();
        this.arcaptchaVerified = false;
        this.arcaptchaToken = '';
      }
    },
  },

};
</script>

<style scoped>
.fa-phone-alt{
  width: 27px!important;
  height: 27px!important;
}
</style>